// extracted by mini-css-extract-plugin
export default {"mainContainer":"LayoutDashboardPage_mainContainer__1h4TS"};